import axios from "axios";
import React, { useMemo, useEffect, useState } from "react";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import MaterialReactTable from "material-react-table";
import { Box, Typography } from "@mui/material";
import EditaGestion from "./EditaAccionMejora";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

function AccionMejora(props) {
  const cookie = new Cookies();
  const [list, setList] = useState([]);
  const [adjunto, setAdjunto] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerGestionesPorIdOm/${props.idOm}`,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.idOm]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerAjuntoOm/${props.idOm}`,
    })
      .then((Response) => {
        setAdjunto(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.idOm]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        filterVariant: "text",
      },
      {
        accessorKey: "omId",
        header: "omId",
        filterVariant: "text",
      },
      {
        accessorKey: "estado",
        header: "Estado",
        filterVariant: "text",
      },
      {
        accessorKey: "fechaCreacion",
        header: "Fecha Creacion",
        filterVariant: "text",
      },
      {
        accessorKey: "fechaModificacion",
        header: "fechaModificacion",
        filterVariant: "text",
      },
      {
        accessorKey: "comentarios",
        header: "Hallazgo",
        filterVariant: "text",
      },
      {
        accessorKey: "accionMejora",
        header: "accionMejora",
        filterVariant: "text",
      },
      {
        accessorKey: "elementoVerificacion",
        header: "elementoVerificacion",
        filterVariant: "text",
      },
      {
        accessorKey: "observacion",
        header: "observacion",
        filterVariant: "text",
      },
      {
        accessorKey: "comentarios",
        header: "comentarios",
        filterVariant: "text",
      },
    ],
    [],
  );
  // Función para eliminar evidencia
  const eliminarAdjunto = (id) => {
    if (window.confirm("¿Está seguro de eliminar esta evidencia?")) {
      axios({
        method: "delete",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://suadesarrollo.azurewebsites.net/api/EliminarAdjuntoOm/${id}`,
        data: {
          TipoAccion: "Eliminación de registro de adjunto om",
          IdUsuario: cookie.get("id"),
        },
      })
        .then((response) => {
          // Filtrar la lista de adjuntos para actualizar la tabla
          setAdjunto(adjunto.filter((item) => item.id !== id));
          alert("Evidencia eliminada correctamente");
        })
        .catch((error) => {
          console.log(error);
          alert("Error al eliminar la evidencia");
        });
    }
  };

  return (
    <div>
      <button
        variant="contained"
        className={list.length ? "btn btn-secondary" : "btn btn-primary"}
        color={list.length ? "secondary" : "primary"}
        onClick={handleOpenModalTest}
      >
        Ver gestiones
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Acciones a Implementar
                  </h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <MaterialReactTable
                      columns={columns}
                      data={list}
                      enableEditing
                      enableRowActions
                      initialState={{
                        columnVisibility: {
                          id: false,
                          accionMejora: false,
                          elementoVerificacion: false,
                          observacion: false,
                          comentarios: false,
                        },
                      }}
                      renderDetailPanel={({ row }) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "auto",
                            width: "100%",
                            padding: "10px",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "8px",
                          }}
                        >
                          <Typography
                            sx={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            <b>Acciones Implementadas:</b>{" "}
                            {row.original.accionMejora}
                          </Typography>
                          <Typography
                            sx={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            <b>Elementos Verificación:</b>{" "}
                            {row.original.elementoVerificacion}
                          </Typography>
                          <Typography
                            sx={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            <b>Observaciones:</b> {row.original.observacion}
                          </Typography>
                          <hr />
                          <Typography
                            sx={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            <b>Comentarios evaluador:</b>{" "}
                            {row.original.comentarios &&
                            row.original.comentarios.trim() !== ""
                              ? row.original.comentarios
                              : "Sin comentar esta gestión"}
                          </Typography>
                        </Box>
                      )}
                      renderRowActions={({ row, table }) => (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                          {cookie.get("tipo_Usuario") == 2 &&
                          props.estado != "SOLUCIONADA" ? (
                            <EditaGestion
                              idOm={row.original.omId}
                              comentarios={row.original.comentarios}
                              acciones={row.original.accionMejora}
                              elementos={row.original.elementoVerificacion}
                              idGestion={row.original.id}
                              observacion={row.original.observacion}
                            />
                          ) : (
                            <h></h>
                          )}
                        </Box>
                      )}
                    />
                  </div>
                  <div className="table-responsive">
                    <center>
                      <table
                        className="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellSpacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Evidencias</th>
                            <th>eliminar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {adjunto.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <button
                                  className="btn btn-success"
                                  onClick={() =>
                                    descargarDocumento(item.adjunto)
                                  }
                                >
                                  Descargar Evidencia
                                </button>
                              </td>
                              <td>
                                {props.estado != "SOLUCIONADA" ? (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => eliminarAdjunto(item.id)}
                                  >
                                    Eliminar
                                  </button>
                                ) : (
                                  <h></h>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button className="btn btn-primary " onClick={closeModal}>
          Volver
        </button>
      </ReactModal>
    </div>
  );
}

export default AccionMejora;
